import React from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import CheckRoundedIcon from '@material-ui/icons/CheckRounded';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

import { Checkmark } from 'icons';

const useStyles = makeStyles((theme) => ({
  selectionRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
  },
  selectAll: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  selectedCount: {
    color: theme.palette.text.secondary,
    fontWeight: 400,
  },
  bulkActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
}));

type SelectionBarProps = {
  allSelected: boolean;
  hasSelection: boolean;
  selectedCount: number;
  onToggleAll: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBulkDecline: () => void;
  onBulkApprove: () => void;
};

const SelectionBar = ({
  allSelected,
  hasSelection,
  selectedCount,
  onToggleAll,
  onBulkDecline,
  onBulkApprove,
}: SelectionBarProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.selectionRow}>
      <Box className={classes.selectAll}>
        <Checkbox
          color="primary"
          checked={allSelected}
          icon={<RadioButtonUncheckedIcon />}
          checkedIcon={<Checkmark />}
          onChange={onToggleAll}
        />
        <Typography className={classes.selectedCount}>Select all</Typography>
        {hasSelection && (
          <Typography className={classes.selectedCount}>{selectedCount} selected</Typography>
        )}
      </Box>
      {hasSelection && (
        <Box className={classes.bulkActions}>
          <Button variant="outlined" startIcon={<CloseRoundedIcon />} onClick={onBulkDecline}>
            Decline
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<CheckRoundedIcon />}
            onClick={onBulkApprove}>
            Approve
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default SelectionBar;
